import React, { FC } from 'react'
import styles from './SearchComponents.module.scss'
import classNames from 'classnames'
import OptionLinks from './OptionLinks'
import useSearchProvider from 'components/SA/SearchProvider/hooks/useSearchProvider'

export type OptionObject = {
  label: string
  link: string
}

export type SearchOptionLinksProps = {
  title: string
  options: ReadonlyArray<OptionObject>
  maxOptions?: number
  setIsFocused: (isFocused: boolean) => void
  onRemove?: (label: string) => void
  onSearch: (query: string) => void
  matchedTerm?: string
  highlightMatchedTerms?: boolean
  icon?: 'search' | 'recent-search'
  sectionName?: string
}

const SearchOptionLinks: FC<SearchOptionLinksProps> = ({
  title,
  options,
  maxOptions = 5,
  setIsFocused,
  onRemove,
  onSearch,
  matchedTerm,
  highlightMatchedTerms,
  icon,
  sectionName,
}) => {
  const filteredOptions = options.filter((_, index) => index < maxOptions)

  if (filteredOptions.length === 0) {
    return null
  }

  return (
    <div
      className={classNames(styles.searchOptionsWrapper, {
        [styles.searchOptionsWrapperHover]: Boolean(onRemove),
      })}
    >
      <h5>{title}</h5>
      <div
        className={classNames(styles.searchOptionsContainer, {
          [styles.searchOptionsContainerWithPadding]: !Boolean(onRemove),
        })}
      >
        <OptionLinks
          onRemove={onRemove}
          options={filteredOptions}
          setIsFocused={setIsFocused}
          onSearch={onSearch}
          matchedTerm={matchedTerm}
          highlightMatchedTerms={highlightMatchedTerms}
          icon={icon}
          sectionName={sectionName}
        />
      </div>
    </div>
  )
}

export default SearchOptionLinks
